const chapterSelectors = {
  loading: state => state.chapterReducer.loading,
  chapters: state => state.chapterReducer.chapters,
  darkMode: state => state.chapterReducer.darkMode,
  scrollHorizontal: state => state.chapterReducer.scrollHorizontal,
  fullWidth: state => state.chapterReducer.fullWidth,
};

export default chapterSelectors;